module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_02@3x-de827366c8ee37506f7db55a29d94fbf.webp";